
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { clearAllTokens } from "../utils/storage.utils";

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      // Clear all tokens from Office.js storage
      await clearAllTokens();
    },
    onSuccess: () => {
      // Immediately set user data to null to synchronously update the auth state.
      queryClient.setQueryData(["user"], null);
      queryClient.removeQueries();
    },
    onError: (error) => {
      console.error("Logout failed:", error);

      // Show error toast
      toast.error("Logout Failed", {
        description: "An error occurred during logout. Please try again.",
      });
    },
  });
};

export default useLogout;
